
<div class="grid">

    <div class="col-12">
        <p-card header="Account Deregistration Queue" subheader="" class="ui-card-light" >

            <!--  C R I T E R I A  -->
            <div class="wal-criteria-row">

                @if(isBrandSelectionShown) {
                    <div class="wal-criteria-item">
                        <label for="brandCode">Brand Code:</label>
                        <p-select id ="brandCode" [options]="brandCodes" [(ngModel)]="selectedBrandCode" 
                            (onChange)="onChangeBrand($event)" placeholder="Required"
                            [editable]="false" class="margin-left" [style]="{'width':'100%'}">
                        </p-select>
                    </div>
                }

                <div class="wal-criteria-item">
                    <label for="statusCode">Status:</label>
                    <p-select id ="statusCode" [options]="statusCodes" [(ngModel)]="selectedStatusCode" 
                        class="margin-left" [style]="{'width':'100%'}" [editable]="false">
                    </p-select>
                </div>

                <div class="wal-criteria-item">
                    <label for="accountNumber">Account Number:</label>
                    <input pInputText id="accountNumber" type="text" [(ngModel)]="selectedAccountNumber">
                </div>

                <div class="wal-criteria-item">
                    <label for="dateFrom" class="margin-right">Placement Date From:</label>
                    <p-datePicker id="dateFrom" [(ngModel)]="selectedDateFrom" dateFormat="yy-mm-dd" 
                        [showIcon]="true" class="margin-left">
                    </p-datePicker>
                </div>

                <div class="wal-criteria-item">
                    <label for="dateTo" class="margin-left">Placement Date To:</label>
                    <p-datePicker id="dateTo" [(ngModel)]="selectedDateTo" dateFormat="yy-mm-dd" 
                        [showIcon]="true" class="margin-left">
                    </p-datePicker>
                </div>

                <div class="wal-criteria-item wal-criteria-actions">
                    <p-button label="Search" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" 
                        (click)="onSearchClick($event)" [disabled]="!selectedBrandCode">
                    </p-button>
                    <p-button label="Clear" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" 
                        (click)="onClearClick($event)">
                    </p-button>
                </div>
    
                <div class="wal-criteria-item wal-criteria-status">
                    <div class="col-2" id="idSpinner" [hidden]="isSpinnerHidden">
                    <div class="loader"></div>  
                    </div>
                </div>

            </div>  

            <!--  G R I D  -->
            
            <div class="grid w-full">

                <div class="col-10">                
                    <p-table #dtDeregQueue [columns]="accountDeregQueueCols" [value]="accountDeregQueue" 
                        selectionMode="single" 
                        [(selection)]="selectedRecord" class="p-datatable-striped p-datatable-sm wal-table"

                        [lazy]="true" [loading]="loading" (onLazyLoad)="loadAccountDeregQueueLazy($event)" 
                        [totalRecords]="totalRecords"
                        [showCurrentPageReport]="false" dataKey="accountDeathRowId"

                        [scrollable]="true"  
                        [virtualScroll]="false"  
                        [virtualScrollItemSize]="10"
                        [scrollHeight]="'50vh'"

                        sortMode="multiple" (onRowSelect)="onRowSelect($event)" [paginator]="true" [rows]="10">
                        <ng-template pTemplate="caption">
                        List of Accounts in Deregistration Queue
                        </ng-template>
    <!-- 
                        <ng-template pTemplate="caption">
                            <div style="text-align: right">        
                                <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
                                <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dtDeregQueue.filterGlobal($any($event.target).value, 'contains')" style="width:auto">
                            </div>
                        </ng-template>
    -->
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <!-- <th style="width: 2.25em"></th> -->
                            @for (col of columns; track col.field) {
                                <th [pSortableColumn]="col.field"
                                    [style.display]="col.display"
                                    [style.width]="col.width"
                                    
                                    [style.textAlign]="col.centered ? 'center' : 'left'"
                                    [style.whiteSpace]="'normal'"
                                    [style.lineHeight]="'1.3em'"                                    
                                >
                                    {{ col.header }}
                                    <!-- <p-sortIcon [field]="col.field"></p-sortIcon> -->
                                </th>
                            }
                            </tr>
                        </ng-template>

                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
                            <tr [pSelectableRow]="rowData">
<!-- 
                            <td [ngStyle]="{'width': '3%'}">
                                <button type="button" pButton pRipple [pRowToggler]="rowData" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                            </td>
-->
                                @for (col of columns; track col.field) {
                                    <td 
                                        [style.width]="col.width" 
                                        [style.display]="col.display" 
                                        [style.textAlign]="col.centered ? 'center' : 'left'">
                                        {{ rowData[col.field] }}
                                    </td>
                                }
                            </tr>
                        </ng-template>
<!-- 
                        <ng-template pTemplate="expandedrow" let-rowData>
                        <tr>
                            <td [attr.colspan]="4">
                            <div class="ui-g ui-fluid" style="font-size:11px;padding:7px">
                                <div class="ui-g-12 ui-md-9">
                                    <div class="grid">
                                        <div class="col-12">
                                            <b>Account Details:</b>
                                            <ul>
                                                @for (entry of getAccountDataPoints(rowData); track $index) {
                                                <li>
                                                    {{ entry[0] }}: {{ entry[1] }}
                                                </li>
                                                }
                                            </ul>                                               
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </td>
                        </tr>
                        </ng-template>
 -->
                        <ng-template pTemplate="summary">
                            <div style="text-align:left">
                                <div class="ui-helper-clearfix">
                                    <p-button styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left float-right"
                                        label="Export" (click)="onFileCreationRequest($event)" [disabled]="!selectedBrandCode">
                                    </p-button> 
                                </div>
                            </div>
                        </ng-template>   

                    </p-table> 

                </div>
            </div>

            <p-footer>
                <mat-icon class="nav-caption wal-center">account_balance</mat-icon>
            </p-footer>

    </p-card>


<p-confirmDialog class="lf-confirm-dialog" appendTo="body" key="account-dereg-queue"></p-confirmDialog>

<!-- <p *ngIf="loading" style="text-align:center; margin-top:10px;">Loading...</p> -->


    </div>            

</div>    


<!-- 

<div class="container">
  <h2>Account Deregistration Queue</h2>

  <div *ngIf="!isSpinnerHidden" class="spinner">Loading...</div>

    <table class="cdk-table header-table">
        <tr class="cdk-header-row">
        <th class="cdk-header-cell">Rec ID</th>
        <th class="cdk-header-cell">Account ID</th>
        <th class="cdk-header-cell">Status</th>
        </tr>
    </table>

    <cdk-virtual-scroll-viewport itemSize="50" class="viewport" (scrolledIndexChange)="onScroll($event)">

        <table cdk-table [dataSource]="_items" class="cdk-table">

            <ng-container cdkColumnDef="accountDeathRowId">
                <th cdk-header-cell *cdkHeaderCellDef>Rec ID</th>
                <td cdk-cell *cdkCellDef="let row">{{ row.accountDeathRowId }}</td>
            </ng-container>

            <ng-container cdkColumnDef="extAccountId">
                <th cdk-header-cell *cdkHeaderCellDef>Account ID</th>
                <td cdk-cell *cdkCellDef="let row">{{ row.extAccountId }}</td>
            </ng-container>

            <ng-container cdkColumnDef="status">
                <th cdk-header-cell *cdkHeaderCellDef>Status</th>
                <td cdk-cell *cdkCellDef="let row">{{ row.status }}</td>
            </ng-container>

            <tr cdk-header-row *cdkHeaderRowDef="displayedColumns; sticky: true" class="sticky-header"></tr>
            <tr cdk-row *cdkRowDef="let row; columns: displayedColumns"></tr>
        </table>
        
    </cdk-virtual-scroll-viewport>

</div> 
-->